export default {"src":"/_next/static/media/logo-and-text-on-dark.86efd8f2.svg","height":33,"width":167};